import {
  CART_VIEWED_EVENT_NAME,
  CART_VIEWED_TRACK_EVENT_SCHEMA,
} from './event-formatting/cart-viewed';
import {
  PRODUCT_REMOVED_EVENT_SCHEMA,
  PRODUCT_REMOVED_EVENT_NAME,
} from './event-formatting/product-removed';
import { CHECKOUT_INTENT_START, CHECKOUT_INTENT_START_EVENT_SCHEMA } from './constants';

// NOTE: If there is an event name that is duplicated among wishlist
// and cart page, do not put it in this lookup, it should be set in rules.js
const eventNameLookup = {
  [CART_VIEWED_EVENT_NAME]: CART_VIEWED_TRACK_EVENT_SCHEMA,
  [PRODUCT_REMOVED_EVENT_NAME]: PRODUCT_REMOVED_EVENT_SCHEMA,
  [CHECKOUT_INTENT_START]: CHECKOUT_INTENT_START_EVENT_SCHEMA,
};

export default eventNameLookup;
